module.exports = __webpack_public_path__ + "static/media/groovy_goldfish.a57491f8.png";